<script>
import { CdrButton, CdrModal, CdrText } from '@rei/cedar';
import ModalContent from './modalContent.vue';
import metrics from '../../../mixins/metrics';

export default {
  name: 'NotifyMe',
  components: {
    CdrButton,
    CdrModal,
    CdrText,
    ModalContent,
  },
  mixins: [metrics],
  props: {
    modalData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modalOpened: false,
      modalTitle: 'Notify me',
    };
  },
  methods: {
    openModal() {
      this.$refs.modalContent.reset();
      if (this.modalTitle !== 'Notify me') {
        this.modalTitle = 'Notify me';
      }
      this.modalOpened = true;
      this.metricsClick({ linkName: '{{ pageName }}_notify me modal_open' });
      this.$emit('open-modal');
    },
    closeModal() {
      this.modalOpened = false;
      this.metricsClick({ linkName: '{{ pageName }}_notify me modal_close' });
      this.$emit('close-modal');
    },
    updateTitle(newTitle) {
      this.modalTitle = newTitle;
    },
  },
};
</script>

<template>
  <div class="notify-me">
    <CdrButton
      :full-width="true"
      aria-haspopup="dialog"
      class="notify-me__modal-trigger"
      data-ui="event-details-registration-status-button"
      modifier="secondary"
      size="large"
      @click="openModal"
    >
      Join the waitlist
    </CdrButton>
    <CdrModal
      :opened="modalOpened"
      label="Notify me"
      aria-described-by="notify-me-description"
      @closed="closeModal"
    >
      <template #title>
        <CdrText
          tag="h3"
          class="notify-me__title"
        >
          {{ modalTitle }}
        </CdrText>
      </template>
      <ModalContent
        ref="modalContent"
        :event-data="modalData"
        @update-title="updateTitle"
        @close-modal="closeModal"
      />
    </CdrModal>
  </div>
</template>
